import { render } from "./cellViewDetail.vue?vue&type=template&id=d0685f76&scoped=true"
import script from "./cellViewDetail.vue?vue&type=script&lang=js"
export * from "./cellViewDetail.vue?vue&type=script&lang=js"

import "./cellViewDetail.vue?vue&type=style&index=0&id=d0685f76&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d0685f76"

export default script